import { useRef, useState } from "react";
import { Upload, FileDown } from "lucide-react";
import { toast } from "sonner";
import api from "../api";

export default function ImportCsv({ module, onDone, testid }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const me = JSON.parse(localStorage.getItem("dyntra_connect_user") || "{}");
  if (!["super_admin", "owner", "admin"].includes(me.level || "")) return null;

  const upload = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setBusy(true);
    const fd = new FormData();
    fd.append("file", file);
    try {
      const r = await api.post(`/connect/import/${module}`, fd);
      const d = r.data;
      if (d.inserted > 0) toast.success(`Imported ${d.inserted} record(s)${d.skipped ? `, skipped ${d.skipped}` : ""}`);
      else toast.warning(`Nothing imported — ${d.errors?.[0] || "check the CSV format"}`);
      if (d.errors?.length && d.inserted > 0) toast.info(`Skipped rows: ${d.errors.join(" · ")}`);
      onDone?.();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Import failed — please upload a CSV file");
    }
    setBusy(false);
  };

  const template = async () => {
    try {
      const r = await api.get(`/connect/import/${module}/template`, { responseType: "blob" });
      const url = URL.createObjectURL(new Blob([r.data], { type: "text/csv" }));
      const a = document.createElement("a");
      a.href = url;
      a.download = `${module}-template.csv`;
      a.click();
      URL.revokeObjectURL(url);
    } catch {
      toast.error("Could not download the template");
    }
  };

  return (
    <div className="flex items-center gap-2">
      <input ref={ref} type="file" accept=".csv" className="hidden" onChange={upload} data-testid={`${testid}-file`} />
      <button data-testid={testid} onClick={() => ref.current?.click()} disabled={busy}
        className="inline-flex items-center gap-2 rounded-full border border-teal-brand/30 bg-teal-soft px-4 py-2.5 text-xs font-bold text-teal-brand hover:bg-teal-brand hover:text-white transition-all disabled:opacity-50">
        <Upload className="h-4 w-4" /> {busy ? "Importing..." : "Import CSV"}
      </button>
      <button data-testid={`${testid}-template`} onClick={template} title="Download CSV template"
        className="inline-flex items-center gap-1.5 rounded-full px-2.5 py-2.5 text-[11px] font-bold text-slate-400 hover:text-teal-brand transition-colors">
        <FileDown className="h-4 w-4" /> Template
      </button>
    </div>
  );
}
